import { createStyles } from 'antd-style';

export const useQuoteConversionStyles = createStyles(({ token }) => ({
  quoteConversionDialog: {
    '&&': {
      '.ant-typography': {
        '&:not(.nl-as-newline)': {
          fontSize: 24,
          marginBottom: 18,
        },

        '&.nl-as-newline': {
          fontWeight: 500,

          '&:first-of-type': {
            marginBottom: token.margin,
          },
        },
      },
    },
  },
}));
